import React, { useEffect, useState } from 'react';

import { Box, Tabs, Tab, TextField, Typography } from '@mui/material';

import '../AdminContent.scss';
import {
  useCreateOrUpdateMiscMutation,
  useGetMiscByKeyQuery,
  useSendAIRequestMutation,
} from '../../../common/apis/AdminApi';
import { useUserRole } from '../../../common/hooks/useUserRole';
import { UserRoles } from '../../../common/types/User';

import { LoadingButton } from '@mui/lab';

const AIPlayground: React.FC = () => {
  const { userRole } = useUserRole();

  const { data: initialMisc, isFetching } = useGetMiscByKeyQuery(
    'custom_prompt',
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const [updateMisc, { isLoading: isUpdateMiscLoading }] =
    useCreateOrUpdateMiscMutation();

  const [sendAIRequest, { isLoading: AIisLoading, data: AIResponse }] =
    useSendAIRequestMutation();

  const [promptValue, setPromptValue] = useState('');
  const [yourMessage, setYourMessage] = useState('');

  const [tab, setTab] = React.useState(0);

  useEffect(() => {
    if (initialMisc) {
      setPromptValue(initialMisc.value);
    }
  }, [initialMisc]);

  if (userRole !== UserRoles.SUPER_ADMIN) {
    return <></>;
  }

  const configTab = () => {
    return (
      <Box sx={{ width: '100%' }}>
        <h3>Custom Prompt</h3>
        <TextField
          placeholder='Enter a custom prompt...'
          size='small'
          value={promptValue}
          color='primary'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPromptValue(e.target.value)
          }
          disabled={isFetching || isUpdateMiscLoading}
          multiline
          rows={12}
          sx={{
            backgroundColor: '#fff',
            borderColor: 'divider.main',
            width: '100%',
            minHeight: '240px',
            maxHeight: '600px',
            [`& fieldset`]: {
              borderRadius: '16px',
            },
          }}
          InputProps={{
            style: {
              width: '100%',
            },
          }}
        />
        <Box
          sx={{
            width: '100%',
            marginTop: '24px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <LoadingButton
            onClick={() =>
              updateMisc({ key: 'custom_prompt', value: promptValue })
            }
            loading={isUpdateMiscLoading}
            disabled={isFetching}
            disableElevation
            color='primary'
            variant='contained'
            sx={{
              borderRadius: '48px',
              height: '48px',
              px: '48px',
            }}
          >
            <Typography color='white'>Save prompt</Typography>
          </LoadingButton>
        </Box>
      </Box>
    );
  };

  const playgroundTab = () => {
    return (
      <Box sx={{ width: '100%' }}>
        <h3>Playground Chat</h3>
        <TextField
          placeholder='Enter your note...'
          size='small'
          value={yourMessage}
          color='primary'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setYourMessage(e.target.value)
          }
          disabled={isFetching || isUpdateMiscLoading || AIisLoading}
          multiline
          rows={12}
          sx={{
            backgroundColor: '#fff',
            borderColor: 'divider.main',
            width: '100%',
            minHeight: '240px',
            maxHeight: '600px',
            [`& fieldset`]: {
              borderRadius: '16px',
            },
          }}
          InputProps={{
            style: {
              width: '100%',
            },
          }}
        />
        <Box
          sx={{
            width: '100%',
            marginTop: '24px',
            marginBottom: '24px',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <LoadingButton
            onClick={() => sendAIRequest(yourMessage)}
            loading={AIisLoading}
            disabled={isFetching || yourMessage === ''}
            disableElevation
            color='primary'
            variant='contained'
            sx={{
              borderRadius: '48px',
              height: '48px',
              px: '48px',
            }}
          >
            <Typography color='white'>Send</Typography>
          </LoadingButton>
        </Box>
        {AIResponse && (
          <Box
            sx={{
              width: '100%',
              marginBottom: '24px',
              padding: '12px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: '#e9f2fe',
              color: '#002145d9',
            }}
          >
            <Typography>{AIResponse}</Typography>
          </Box>
        )}
      </Box>
    );
  };

  // AI PLAYGROUND
  return (
    <Box className='white-background min-height-100'>
      <Box
        style={{
          textAlign: 'center',
          paddingTop: '24px',
        }}
      >
        <h1>AI PLAYGROUND</h1>
      </Box>
      <Box
        style={{
          padding: '30px',
          width: '100%',
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, value) => setTab(value)}
          disabled={AIisLoading}
        >
          <Tab label='Playground' />
          <Tab label='Config' />
        </Tabs>
        {tab === 0 && playgroundTab()}
        {tab === 1 && configTab()}
      </Box>
    </Box>
  );
};

export default AIPlayground;
